// Current Dropbox-backed test dataset for the 4-track album mixer.
export const albumMixerSongs = [
  {
    id: "sud",
    title: "Sud",
    side: "A",
    sideIndex: 1,
    tracks: [
      { id: "1", title: "Track 1", url: "https://www.dropbox.com/scl/fi/zgsy9i6oyyc1b0twc0x0o/1.mp3?rlkey=cepxn8sfb78gqcdubtigj0l28&st=quuattk9&dl=0" },
      { id: "2", title: "Track 2", url: "https://www.dropbox.com/scl/fi/uv21x5z6xt9cyb1k7xdk4/2.mp3?rlkey=x25t0mgvjm613lvtw3k2ii5qd&st=dkj0e1z2&dl=0" },
      { id: "3", title: "Track 3", url: "https://www.dropbox.com/scl/fi/y2lthp1q9jln9h9xq9ut6/3.mp3?rlkey=d07qon36cmmqslihmyn22hor2&st=u67v60r3&dl=0" },
      { id: "4", title: "Track 4", url: "https://www.dropbox.com/scl/fi/0gcmw5oxzsry9bzf491hp/4.mp3?rlkey=inza92nn2f3g33marzxe1zuld&st=50awcoai&dl=0" },
    ],
  },
  {
    id: "forsmekkur",
    title: "Forsmekkur",
    side: "A",
    sideIndex: 2,
    tracks: [
      { id: "1", title: "Track 1", url: "https://www.dropbox.com/scl/fi/0gxiy8foct7wc4ety9sjs/1.mp3?rlkey=ypqrnkchwvo3s993s9jpnqdom&st=twoye4dc&dl=0" },
      { id: "2", title: "Track 2", url: "https://www.dropbox.com/scl/fi/zj6z5l48tu2kete4ievm5/2.mp3?rlkey=070cu7rizalysjvxqj48m0b5u&st=k3vjt449&dl=0" },
      { id: "3", title: "Track 3", url: "https://www.dropbox.com/scl/fi/436t3f7r180di9rz5jpma/3.mp3?rlkey=04r7g3d7mowsvu1ydsomdl3kl&st=0uzit6ot&dl=0" },
      { id: "4", title: "Track 4", url: "https://www.dropbox.com/scl/fi/scjf69pu1ngu083y0g0af/4.mp3?rlkey=tsramre7ztxn2udx5nxls2xgf&st=uxylybvp&dl=0" },
    ],
  },
  {
    id: "tu-koko",
    title: "Tú-Kókó",
    side: "A",
    sideIndex: 3,
    tracks: [
      { id: "1", title: "Track 1", url: "https://www.dropbox.com/scl/fi/13j3fudow85byz31ul0ng/1.mp3?rlkey=1o3fwdeo9fsmaasjls1vmnvqz&st=6r9gz2ok&dl=0" },
      { id: "2", title: "Track 2", url: "https://www.dropbox.com/scl/fi/hqf1p139zwzpn1ribu9u1/2.mp3?rlkey=sq1sn7p9r5fduzyqowa2acjlm&st=y5e5h0an&dl=0" },
      { id: "3", title: "Track 3", url: "https://www.dropbox.com/scl/fi/3x8loz2zspr6a9iyztj7p/3.mp3?rlkey=refhlyfhf91stvcdu7lvykabr&st=8tyimiw5&dl=0" },
      { id: "4", title: "Track 4", url: "https://www.dropbox.com/scl/fi/mnffw1fsyeburoivg81of/4.mp3?rlkey=trvo7n19utspqn141kkpeuihq&st=a28ic9dv&dl=0" },
    ],
  },
  {
    id: "jeppi-net",
    title: "Jeppi/Net",
    side: "A",
    sideIndex: 4,
    tracks: [
      { id: "1", title: "Track 1", url: "https://www.dropbox.com/scl/fi/hflt0eq0z8b9jddh9ct4e/1.mp3?rlkey=f3ndqsxd4r77bodtmsfxndk8r&st=lwi2rmqf&dl=0" },
      { id: "2", title: "Track 2", url: "https://www.dropbox.com/scl/fi/xqexn3ec0lnq4hivepffp/2.mp3?rlkey=5maivs7cmb006elunzn5o383n&st=s7sk6o05&dl=0" },
      { id: "3", title: "Track 3", url: "https://www.dropbox.com/scl/fi/l9q75j7g3ckxhmlfmd8hd/3.mp3?rlkey=ui4hdmprr86t5v5pzzv5bk5jl&st=bbcjbzvt&dl=0" },
      { id: "4", title: "Track 4", url: "https://www.dropbox.com/scl/fi/kspeknwrx7je4ql8kd5n9/4.mp3?rlkey=yvu9z6kji52y6ms6l1tlx4g3k&st=nz4v8x8k&dl=0" },
    ],
  },
  {
    id: "spola",
    title: "Spóla",
    side: "B",
    sideIndex: 1,
    tracks: [
      { id: "1", title: "Track 1", url: "https://www.dropbox.com/scl/fi/r7bhvawo0ibk52u4ta2ia/1.mp3?rlkey=c8daev8tmburrmvrkoukgijk6&st=4a3rk04i&dl=0" },
      { id: "2", title: "Track 2", url: "https://www.dropbox.com/scl/fi/7zojfskh3d9tnmi6wqog7/2.mp3?rlkey=nvqrgkf0joo56kmnw1vxt1am6&st=a2hlv9a7&dl=0" },
      { id: "3", title: "Track 3", url: "https://www.dropbox.com/scl/fi/8esu7tkgu5yklkmv8vng5/3.mp3?rlkey=bn1dk2nb2q7cru0c3t8lknp34&st=oefn04d3&dl=0" },
      { id: "4", title: "Track 4", url: "https://www.dropbox.com/scl/fi/4o37pmi2dmmixltyas5iq/4.mp3?rlkey=cnpribh02xj2t4sl66o827skf&st=23z4b8x5&dl=0" },
    ],
  },
  {
    id: "prestur",
    title: "Prestur",
    side: "B",
    sideIndex: 2,
    tracks: [
      { id: "1", title: "Track 1", url: "https://www.dropbox.com/scl/fi/9g7bokxqpdrgr16r9dvaz/1.mp3?rlkey=7a0mbchhes6a5qg4r0a2mlt6c&st=x5pzqjha&dl=0" },
      { id: "2", title: "Track 2", url: "https://www.dropbox.com/scl/fi/tl51k4a776np4fd466apz/2.mp3?rlkey=8m03p40hgi2bdskthp09oakut&st=3bmo0f37&dl=0" },
      { id: "3", title: "Track 3", url: "https://www.dropbox.com/scl/fi/fpuu570d9aihi1yey3gmg/3.mp3?rlkey=paxl3dnexkwb1vkwspmpgxmtw&st=9i90s4me&dl=0" },
      { id: "4", title: "Track 4", url: "https://www.dropbox.com/scl/fi/a940y5xbkgji1qvy1ycja/4.mp3?rlkey=y95i77mp6pp4cli8ie0r85k68&st=uk7ls9th&dl=0" },
    ],
  },
  {
    id: "sturtudrengur",
    title: "Sturtudrengur",
    side: "B",
    sideIndex: 3,
    tracks: [
      { id: "1", title: "Track 1", url: "https://www.dropbox.com/scl/fi/72wf04peul4p9i1qwpo60/1.mp3?rlkey=1dvgbfdusipi347psm7cyf0xm&st=pkpqek2k&dl=0" },
      { id: "2", title: "Track 2", url: "https://www.dropbox.com/scl/fi/ograninvnde6zf8txjayb/2.mp3?rlkey=ymecvwo07oky35bdi5sw9ix2x&st=i4murf85&dl=0" },
      { id: "3", title: "Track 3", url: "https://www.dropbox.com/scl/fi/dreo46i530qa781guwef2/3.mp3?rlkey=rpaj5o7cdzq3j7sf0npjiovo2&st=s0bks9bb&dl=0" },
      { id: "4", title: "Track 4", url: "https://www.dropbox.com/scl/fi/1fi90cdpjaolfgxvgvpno/4.mp3?rlkey=xbcjrmv2748e96im9sq1i50ir&st=635huu6j&dl=0" },
    ],
  },
  {
    id: "gloria",
    title: "Gloria",
    side: "B",
    sideIndex: 4,
    tracks: [
      { id: "1", title: "Track 1", url: "https://www.dropbox.com/scl/fi/3xc5zi4lxom331go574rz/1.mp3?rlkey=wiqz56rxbr3hiu5murgbitohk&st=ghlgtet4&dl=0" },
      { id: "2", title: "Track 2", url: "https://www.dropbox.com/scl/fi/ohsyqwffuq5bev9t079n5/2.mp3?rlkey=otso51wid23ciuqyyzgjjd0zt&st=en87r3ds&dl=0" },
      { id: "3", title: "Track 3", url: "https://www.dropbox.com/scl/fi/jibaxw8ygxmypzzq8nci9/3.mp3?rlkey=bpxxsihbdlkf9kpun1nooys5r&st=s0064tck&dl=0" },
      { id: "4", title: "Track 4", url: "https://www.dropbox.com/scl/fi/0v3cdudm5bsp5ezqf3dce/4.mp3?rlkey=evs94sdvwhg5ufv96fhdswqxp&st=m3dkwsj7&dl=0" },
    ],
  },
  {
    id: "velknuin-ond",
    title: "Vélknúin Önd",
    side: "B",
    sideIndex: 5,
    tracks: [
      { id: "1", title: "Track 1", url: "https://www.dropbox.com/scl/fi/xix3dsi6q68ye0vtda929/1.mp3?rlkey=xagdu3pekd1rfjt80k0duj3xp&st=trqgzglv&dl=0" },
      { id: "2", title: "Track 2", url: "https://www.dropbox.com/scl/fi/d3faubt2g2j2ohs4y3yh9/2.mp3?rlkey=zqeohfa999cjg38x554cvwinq&st=t507qwzz&dl=0" },
      { id: "3", title: "Track 3", url: "https://www.dropbox.com/scl/fi/fp8qcf879tddvznbuplm5/3.mp3?rlkey=55tm4a88t6dd6dtm3ktrod10n&st=pbvaimqi&dl=0" },
      { id: "4", title: "Track 4", url: "https://www.dropbox.com/scl/fi/pm3clkuizb7yv7jby98jo/4.mp3?rlkey=ggw52d4fou23hghszad9klh67&st=xmy7l2t9&dl=0" },
    ],
  },
];
